<template>
    <div class="pa-pills" role="tablist">
        <button v-for="item in items" :key="item.value" type="button" role="tab" class="pa-pill"
            :class="{ 'pa-pill--active': item.value === value }" :aria-selected="item.value === value" @click="$emit('input', item.value)">
            <span v-if="item.tone" class="pa-pill__dot" :class="`pa-pill__dot--${item.tone}`"></span>
            {{ item.text }}
            <span v-if="item.value === value && item.count !== undefined" class="pa-pill__count">{{ formatCount(item.count) }}</span>
        </button>
    </div>
</template>

<script>
// Filtro rapido em pilulas (Todas, Pendentes, Aprovadas...). A quantidade
// aparece na pilula ativa. items: [{ value, text, tone?, count? }].
export default {
    name: "PaPills",
    props: {
        value: { type: [String, Number], default: null },
        items: { type: Array, required: true },
    },
    methods: {
        formatCount(value) {
            return Number(value || 0).toLocaleString("pt-BR");
        },
    },
};
</script>
